import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import {
  AddPrinterParams,
  AddPrinterResponse,
  Printer,
  PrinterTypesResponse,
} from './printers.model';
import { GenericApiResponse, PaginationParams } from '../general-store/general.model';

interface PrintersResponse extends GenericApiResponse {
  payload: Printer[];
}

interface PrinterTypesApiResponse extends GenericApiResponse {
  payload: PrinterTypesResponse;
}

@Injectable({ providedIn: 'root' })
export class PrintersService {
  private readonly apiUrl = environment.apiUrl + '/api/printers/';

  private readonly http = inject(HttpClient);

  listPrinters(params?: PaginationParams): Observable<PrintersResponse> {
    let httpParams = new HttpParams();

    if (params) {
      const page = params.first / params.rows + 1;
      httpParams = httpParams.set('page', page.toString());
      httpParams = httpParams.set('limit', params.rows.toString());

      if (params.sortBy) {
        httpParams = httpParams.set('sortBy', params.sortBy);
      }
      if (params.sortOrder) {
        httpParams = httpParams.set('sortOrder', params.sortOrder);
      }
      if (params.search) {
        httpParams = httpParams.set('search', params.search);
      }
      if (params.filters) {
        httpParams = httpParams.set('filters', params.filters);
      }
    }

    return this.http.get<PrintersResponse>(this.apiUrl, { params: httpParams });
  }

  getPrinterTypes(): Observable<PrinterTypesApiResponse> {
    return this.http.get<PrinterTypesApiResponse>(environment.apiUrl + '/api/data/printer-types');
  }

  addPrinter(printer: AddPrinterParams): Observable<AddPrinterResponse> {
    return this.http.post<AddPrinterResponse>(this.apiUrl, printer);
  }

  updatePrinter(id: number, printer: AddPrinterParams): Observable<Printer> {
    return this.http.put<Printer>(this.apiUrl + id, printer);
  }

  deletePrinter(id: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(this.apiUrl + id);
  }
}
